import { UserContext } from "context/userContext"
import { UserModel } from "model/UserModel"
import { FC, useContext } from "react"
import { Navigate } from "react-router-dom"
import { getHomeUrl } from "util/route"

// Корень и несуществующие адреса были пустой страницей —
// теперь ведут на первый доступный пункт сайдбара
export const HomeRedirect: FC = () => {
  const user = useContext<UserModel>(UserContext)
  const homeUrl = getHomeUrl(user)

  if (!homeUrl) {
    return null
  }

  return <Navigate to={`/${homeUrl}`} replace />
}
